/* Program Name: ezpopURL.js
 **  Description: Returns the ezpop.app url with customer information
 **
 ** Project   Date        Who  Comments
 ** --------  ----------  ---  ---------------------------------------------------
 ** IS200324  2022-03-28  caa  Original.
 *******************************************************************************/
//Color for "Dev" server
export const DEV_GREEN = '#139c29'
//Color for "QA" server
export const QA_YELLOW = '#FFCC00'
//strips subdomain from URL
export const subdomain = /:\/\/([^/]+)/
  .exec(window.location.href)[1]
  .split('.')[0]
//application domain
export const ezpopURL = `https://${subdomain}.ezpop.app`
//creates appropriate web path for displaying images from web server
export const webPathURL = (remoteFile, thumbnail) => {
  const placeholder = 'https://placehold.jp/400x400.png'
  if (!remoteFile || typeof remoteFile === 'undefined') return placeholder
  const URI = ezpopURL + remoteFile.webPath
  let path = ''
  let imageType = thumbnail ? 'imageThumb' : 'imageFull'
  let fallback = thumbnail ? 'thumbFallback' : 'fullFallback'

  if (remoteFile[imageType] && remoteFile[imageType] !== '')
    path = URI + remoteFile[imageType]
  else if (remoteFile[fallback] && remoteFile[fallback] !== '')
    path = URI + remoteFile[fallback]
  else path = placeholder
  return path
}
